import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Напоминание, что регистры с 0-2 должны быть занулены при использование внешнего динамика
import * as React from 'react';
import { memo, useCallback, useContext, useMemo } from 'react';
import { Notification } from 'z3k-config';
import { useEditingProps, useGetZ3kObject } from '../utils/unpack-props';
import { MaterialDropdown } from 'console/shared/components/fields';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { select_user_and_roles_options } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { SettingContainer } from '../material-utils/settings-card/container';
import { SettingFullRow } from '../material-utils/settings-card/full-row';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { MultipleSelectionTable, } from '../material-utils/multiple-selection-table/multiple-selection';
import { removeNulls } from 'utils';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { TestNotification } from 'z3k-settings/components/notifications/test-notification';
const outerDynamic = Notification.Flags.SPEAKER_NOTIFICATION_ENABLE &
    (~Notification.Flags.SMS_NOTIFICATION_ENABLE &
        ~Notification.Flags.VOICE_NOTIFICATION_ENABLE &
        ~Notification.Flags.SMS_IF_CALL_FAILED);
const z3k_name = 'notifications';
export const NotificationControl = memo(function NotificationControl() {
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec, deviceFirmwareVersion, sendCommand } = useContext(Z3KSettings);
    const user_and_roles_options = select_user_and_roles_options(config, device_spec);
    const options = useMemo(() => removeNulls([
        {
            text: 'Оповещение по смс',
            value: Notification.Flags.SMS_NOTIFICATION_ENABLE,
        },
        {
            text: device_spec.show_voice_notifications
                ? 'Голосовое оповещение'
                : 'Дозвон',
            value: Notification.Flags.VOICE_NOTIFICATION_ENABLE,
        },
        {
            text: device_spec.show_voice_notifications
                ? 'Голосовое и смс оповещение'
                : 'Дозвон и смс',
            value: Notification.Flags.SMS_NOTIFICATION_ENABLE |
                Notification.Flags.VOICE_NOTIFICATION_ENABLE,
        },
        {
            text: device_spec.show_voice_notifications
                ? 'Оповещение по смс, если голосовое оповещение не удалось'
                : 'Дозвон, в случае неудачи — смс',
            value: Notification.Flags.VOICE_NOTIFICATION_ENABLE |
                Notification.Flags.SMS_IF_CALL_FAILED,
        },
        deviceFirmwareVersion >= 74 && device_spec.io.has_output_dynamic
            ? {
                text: 'Внешний динамик',
                value: outerDynamic,
            }
            : null,
    ]), [deviceFirmwareVersion, device_spec]);
    const sms_selected = useMemo(() => Notification.isSmsEnabled(item) || Notification.isSmsIfCallFailed(item), [item]);
    const voice_selected = useMemo(() => Notification.isVoiceEnabled(item) ||
        Notification.isSpeakerNotificationEnabled(item), [item]);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const smsTextEditingProps = useEditingProps(id, z3k_name, 'sms_text');
    const voiceTextEditingProps = useEditingProps(id, z3k_name, 'voice_text');
    const settingRegisterEditingProps = useEditingProps(id, z3k_name, 'setting_register');
    const multipleSelectionTableOptions = useMemo(() => {
        const result = [];
        if (!Notification.isSpeakerEnabled(item) &&
            !device_spec.show_simple_notification_tab) {
            result.push({
                title: 'Список получателей',
                help_id: 'notifications_recipient_list',
                z3k_field: 'recipient_list',
                options: user_and_roles_options,
            });
        }
        return result;
    }, [item]);
    const type_field = useCallback((input_props) => (_jsx(MaterialDropdown, { ...input_props, options: options })), [options]);
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "notifications_name", ...nameEditingProps }), _jsx(Control, { label: "\u0422\u0438\u043F \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F", ...settingRegisterEditingProps, field: type_field, help_id: "notifications_type" }), sms_selected && (_jsx(Control, { label: "\u0422\u0435\u043A\u0441\u0442 \u0441\u043C\u0441 \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F", field: TextInputWrapper, help_id: "notifications_sms_text", ...smsTextEditingProps })), device_spec.show_voice_notifications && voice_selected && (_jsx(Control, { label: "\u0422\u0435\u043A\u0441\u0442 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0433\u043E \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F", field: TextInputWrapper, help_id: "notifications_voice_text", ...voiceTextEditingProps })), _jsx(TestNotification, { item: item }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false, name_second_column: "\u042D\u043B\u0435\u043C\u0435\u043D\u0442\u044B" }) })] }) }));
});
